import { render, staticRenderFns } from "./WorkOrderStatusDescription.vue?vue&type=template&id=63bcf762"
import script from "./WorkOrderStatusDescription.vue?vue&type=script&lang=ts"
export * from "./WorkOrderStatusDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports